// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import classNames from 'classnames/bind';
import { encodeProduct } from '../../modules/featured-products/utils/encode';
import { Desktop, Mobile, Tablet } from '../../utils/responsive';
import CarouselItems from '../CarouselItems/CarouselItems';

import style from './CarouselProducts.scss';
import buttonStyle from '../../assets/styles/button.scss';

import type { Element } from 'react';
import type { Product } from '../../modules/featured-products/duck';
import type { WishListItem } from '../../entities';

type Props = {
  +title: string;
  +elementTitle?: Element<'div'>;
  +items: Product[] | WishListItem[];
  +url?: string;
  +hasPrices?: boolean;
  +itemLinkToUrl?: boolean;
  +buttonIntl?: string;
  +hasFixedItems?: boolean;
  +isWishList?: boolean;
};

type State = {
  lightningLeftArrow: boolean;
  lightningRightArrow: boolean;
};


export default class CarouselProducts extends Component<Props, State> {
  static defaultProps = {
    hasPrices: true,
    hasFixedItems: true,
  };

  state = {
    lightningRightArrow: false,
    lightningLeftArrow: true,
  };

  handleArrowStyle = (current: number, lastIndex: number) => {
    const lightningLeftArrow = current === 0;
    const lightningRightArrow = current === lastIndex;
    this.setState({ lightningLeftArrow, lightningRightArrow });
  };

  buildItemBox(): Element<'article'>[] {
    const { items, hasPrices, itemLinkToUrl, hasFixedItems, isWishList } = this.props;
    let itemsArray = items;
    if (hasFixedItems) {
      const newItems = [];
      for (let i = 0; i < 5; i++) !!items[i] ? newItems.push(items[i]) : null;
      itemsArray = newItems;
    }
    return itemsArray.map((item: Product | WishListItem, index: number) => {
      // const p: ScrappedProduct;
      const b64 = encodeProduct(item);
      const originType = !!item.originType ? `originType=${item.originType}&` : '';
      let link = !!itemLinkToUrl ? `/new-order/product?${originType}initialQuery=${item.url}` :
        `/new-order/product?${originType}product=${b64}`;
      let target = "_self";
      if (isWishList) {
        link = item.url;
        target = "_blank";
      }
      return (
        <article key={index}>
          {/* TODO: temporary fix, remove the b64 thing later */}
          <a href={link} target={target}>
            <section>
              <img src={item.image} alt="Qempo" draggable="false"/>
            </section>
            <h2>{item.name}</h2>
            {hasPrices && item.price && <p>$ {item.price}</p>}
          </a>
        </article>
      );
    });
  }

  render() {
    const { title, url, buttonIntl, elementTitle, hasFixedItems } = this.props;
    const { lightningLeftArrow, lightningRightArrow } = this.state;
    const carouselItems = this.buildItemBox();
    return (
      <section className={style.carouselOrders}>
        <header>
          <FormattedMessage id={title}>{
            txt => <h2>{elementTitle ? elementTitle : txt}</h2>
          }</FormattedMessage>
          {!!url && <FormattedMessage id="newOrder.scrap.carousel.see.more">{
            txt => <Link className={style.seeMore} to={url}>{txt}</Link>
          }</FormattedMessage>}
        </header>
        <CarouselItems carouselItems={carouselItems}
                       lightningLeftArrow={lightningLeftArrow}
                       lightningRightArrow={lightningRightArrow}
                       handleArrowStyle={this.handleArrowStyle}
                       hasFixedItems={hasFixedItems}/>
        {!!url && !!buttonIntl &&
        <Mobile>
          <section className={style.button}>{
            <FormattedMessage id={buttonIntl}>{
              txt => <Link className={classNames(buttonStyle.btn, buttonStyle.greyInverse,
                style.seeMore)}
                           to={url}>{txt}</Link>
            }</FormattedMessage>
          }</section>
        </Mobile>}
      </section>)
  }
}

CarouselProducts.propTypes = {
  title: PropTypes.string.isRequired,
  elementTitle: PropTypes.object,
  items: PropTypes.array.isRequired,
  url: PropTypes.string,
  hasPrices: PropTypes.bool,
  itemLinkToUrl: PropTypes.bool,
  buttonIntl: PropTypes.string,
  isWishList: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/elements/CarouselProducts/CarouselProducts.jsx